import React from "react";

const Blog = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="512"
      height="512"
      x="0"
      y="0"
      viewBox="0 0 24 24"
    //   style="enable-background:new 0 0 512 512"
      className="size-6"
    >
      <g transform="matrix(1.2200000000000002,0,0,1.2200000000000002,-2.75,-2.5300000000000047)">
        <path
          d="M18.5 4h-12A2.5 2.5 0 0 0 4 6.5v10A2.5 2.5 0 0 0 6.5 19h12a2.5 2.5 0 0 0 2.5-2.5v-3a.5.5 0 0 0-1 0v3a1.5 1.5 0 0 1-1.5 1.5h-12A1.5 1.5 0 0 1 5 16.5V7h15v1a.5.5 0 0 0 1 0V6.5A2.5 2.5 0 0 0 18.5 4zm-12 1h12a1.5 1.5 0 0 1 1.408 1H5.092A1.5 1.5 0 0 1 6.5 5zm6 12h2a.5.5 0 0 0 .354-.146l5.292-5.293a1.5 1.5 0 0 0 0-2.122l-.585-.585a1.5 1.5 0 0 0-2.122 0l-5.293 5.292A.5.5 0 0 0 12 14.5v2a.5.5 0 0 0 .5.5zm6.354-7.439.585.585a.5.5 0 0 1 0 .708l-.439.439L17.707 10l.439-.439a.5.5 0 0 1 .708 0zM13 14.707l4-4L18.293 12l-4 4H13zM6 9.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1h-8a.5.5 0 0 1-.5-.5zm5.5 3.5h-5a.5.5 0 0 1 0-1h5a.5.5 0 0 1 0 1zm-1 2a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1z"
          fill="currentColor"
          opacity="1"
          data-original="#000000"
          class=""
        ></path>
      </g>
    </svg>
  );
};

export default Blog;
